/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EntityDto } from '../models/entity-dto';
import { EventDeliveriesDto } from '../models/event-deliveries-dto';
import { EventDeliveryOrderByEnum } from '../models/event-delivery-order-by-enum';
import { EventDeliveryStatusEnum } from '../models/event-delivery-status-enum';
import { MerchantEventDetailsDto } from '../models/merchant-event-details-dto';
import { MerchantEventOrderByEnum } from '../models/merchant-event-order-by-enum';
import { MerchantEventsDto } from '../models/merchant-events-dto';
import { OrderDirectionEnum } from '../models/order-direction-enum';

@Injectable({
  providedIn: 'root',
})
export class EventsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation eventDeliveriesSearch
   */
  static readonly EventDeliveriesSearchPath = '/v1/admin/events/{eventId}/deliveries';

  /**
   * Retrieves a list of event delieveries for an event.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventDeliveriesSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventDeliveriesSearch$Response(params: {

    /**
     * The event.
     */
    eventId: number;
    OrderBy?: Array<EventDeliveryOrderByEnum>;
    Status?: EventDeliveryStatusEnum;
    StartDate?: string;
    EndDate?: string;
    OrderDirection?: OrderDirectionEnum;
    'Pager.PageSize'?: number;
    'Pager.PageIndex'?: number;
  }): Observable<StrictHttpResponse<EventDeliveriesDto>> {

    const rb = new RequestBuilder(this.rootUrl, EventsService.EventDeliveriesSearchPath, 'get');
    if (params) {
      rb.path('eventId', params.eventId, {});
      rb.query('OrderBy', params.OrderBy, {"style":"form","explode":true});
      rb.query('Status', params.Status, {});
      rb.query('StartDate', params.StartDate, {});
      rb.query('EndDate', params.EndDate, {});
      rb.query('OrderDirection', params.OrderDirection, {});
      rb.query('Pager.PageSize', params['Pager.PageSize'], {});
      rb.query('Pager.PageIndex', params['Pager.PageIndex'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EventDeliveriesDto>;
      })
    );
  }

  /**
   * Retrieves a list of event delieveries for an event.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `eventDeliveriesSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventDeliveriesSearch(params: {

    /**
     * The event.
     */
    eventId: number;
    OrderBy?: Array<EventDeliveryOrderByEnum>;
    Status?: EventDeliveryStatusEnum;
    StartDate?: string;
    EndDate?: string;
    OrderDirection?: OrderDirectionEnum;
    'Pager.PageSize'?: number;
    'Pager.PageIndex'?: number;
  }): Observable<EventDeliveriesDto> {

    return this.eventDeliveriesSearch$Response(params).pipe(
      map((r: StrictHttpResponse<EventDeliveriesDto>) => r.body as EventDeliveriesDto)
    );
  }

  /**
   * Path part for operation eventDeliveriesSend
   */
  static readonly EventDeliveriesSendPath = '/v1/admin/events/{eventId}/deliveries/{id}/send';

  /**
   * Resends an event delievery for an event.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventDeliveriesSend()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventDeliveriesSend$Response(params: {

    /**
     * The event.
     */
    eventId: number;

    /**
     * The event delievery.
     */
    id: number;
  }): Observable<StrictHttpResponse<EntityDto>> {

    const rb = new RequestBuilder(this.rootUrl, EventsService.EventDeliveriesSendPath, 'post');
    if (params) {
      rb.path('eventId', params.eventId, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EntityDto>;
      })
    );
  }

  /**
   * Resends an event delievery for an event.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `eventDeliveriesSend$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventDeliveriesSend(params: {

    /**
     * The event.
     */
    eventId: number;

    /**
     * The event delievery.
     */
    id: number;
  }): Observable<EntityDto> {

    return this.eventDeliveriesSend$Response(params).pipe(
      map((r: StrictHttpResponse<EntityDto>) => r.body as EntityDto)
    );
  }

  /**
   * Path part for operation eventsSearch
   */
  static readonly EventsSearchPath = '/v1/admin/events';

  /**
   * Retrieves a list of merchant events.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsSearch$Response(params?: {
    OrderBy?: Array<MerchantEventOrderByEnum>;
    EventTypes?: Array<string>;
    Mid?: string;
    Tid?: string;
    FundingInstructionRef?: string;
    TransactionId?: string;
    StartDate?: string;
    EndDate?: string;
    OrderDirection?: OrderDirectionEnum;
    'Pager.PageSize'?: number;
    'Pager.PageIndex'?: number;
  }): Observable<StrictHttpResponse<MerchantEventsDto>> {

    const rb = new RequestBuilder(this.rootUrl, EventsService.EventsSearchPath, 'get');
    if (params) {
      rb.query('OrderBy', params.OrderBy, {"style":"form","explode":true});
      rb.query('EventTypes', params.EventTypes, {"style":"form","explode":true});
      rb.query('Mid', params.Mid, {});
      rb.query('Tid', params.Tid, {});
      rb.query('FundingInstructionRef', params.FundingInstructionRef, {});
      rb.query('TransactionId', params.TransactionId, {});
      rb.query('StartDate', params.StartDate, {});
      rb.query('EndDate', params.EndDate, {});
      rb.query('OrderDirection', params.OrderDirection, {});
      rb.query('Pager.PageSize', params['Pager.PageSize'], {});
      rb.query('Pager.PageIndex', params['Pager.PageIndex'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MerchantEventsDto>;
      })
    );
  }

  /**
   * Retrieves a list of merchant events.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `eventsSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsSearch(params?: {
    OrderBy?: Array<MerchantEventOrderByEnum>;
    EventTypes?: Array<string>;
    Mid?: string;
    Tid?: string;
    FundingInstructionRef?: string;
    TransactionId?: string;
    StartDate?: string;
    EndDate?: string;
    OrderDirection?: OrderDirectionEnum;
    'Pager.PageSize'?: number;
    'Pager.PageIndex'?: number;
  }): Observable<MerchantEventsDto> {

    return this.eventsSearch$Response(params).pipe(
      map((r: StrictHttpResponse<MerchantEventsDto>) => r.body as MerchantEventsDto)
    );
  }

  /**
   * Path part for operation eventsGet
   */
  static readonly EventsGetPath = '/v1/admin/events/{id}';

  /**
   * Retrieves info about a merchant event.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsGet$Response(params: {

    /**
     * The merchant event.
     */
    id: number;
  }): Observable<StrictHttpResponse<MerchantEventDetailsDto>> {

    const rb = new RequestBuilder(this.rootUrl, EventsService.EventsGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MerchantEventDetailsDto>;
      })
    );
  }

  /**
   * Retrieves info about a merchant event.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `eventsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventsGet(params: {

    /**
     * The merchant event.
     */
    id: number;
  }): Observable<MerchantEventDetailsDto> {

    return this.eventsGet$Response(params).pipe(
      map((r: StrictHttpResponse<MerchantEventDetailsDto>) => r.body as MerchantEventDetailsDto)
    );
  }

}
